// Copyright 2026, Imprivata, Inc.  All rights reserved.

export const PASSWORD_EXPIRATION_WARNING_DAYS = 14;

export const getDaysUntilExpiration = (expiresAt?: string | null): number | null => {
  if (!expiresAt) {
    return null;
  }
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  const expiration = new Date(expiresAt);

  const now = new Date();
  // UTC midnights of the local dates: local midnights are 23 or 25 hours apart across a DST change.
  const startOfToday = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const startOfExpiration = Date.UTC(
    expiration.getFullYear(),
    expiration.getMonth(),
    expiration.getDate(),
  );
  const daysLeft = (startOfExpiration - startOfToday) / MS_PER_DAY;

  // If already expired
  if (expiration.getTime() < now.getTime()) {
    return -1;
  }

  // If expires today (24h or less)
  if (daysLeft === 0 && expiration.getTime() > now.getTime()) {
    return 1;
  }

  return Math.max(0, daysLeft);
};
